export default __webpack_public_path__ + "media/zurb/img/ecommerce/cp_pdp-7b653e5e8a7cb8577de0e3df1b5eb659.png";